(function () {
  var RECENT_KEY = 'tbd_recently_viewed';
  var LEGACY_RECENT_KEY = 'vervewave_recently_viewed';
  var WISHLIST_KEY = 'tbd_saved_products';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function readRecent() {
    try {
      var saved = localStorage.getItem(RECENT_KEY);
      if (!saved) saved = localStorage.getItem(LEGACY_RECENT_KEY);
      return JSON.parse(saved || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeRecent(items) {
    localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 12)));
  }

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items.slice(0, 60)));
    updateWishlistUI();
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function trackCurrentProduct() {
    var node = qs('[data-current-product]');
    if (!node) return;

    try {
      var product = JSON.parse(node.textContent);
      var items = readRecent().filter(function (item) {
        return item.id !== product.id;
      });
      items.unshift(product);
      writeRecent(items);
    } catch (error) {
      return;
    }
  }

  function renderRecent() {
    var wrap = qs('[data-recently-viewed]');
    var grid = qs('[data-recently-viewed-grid]');
    if (!wrap || !grid) return;

    var items = readRecent().slice(0, 8);
    if (!items.length) return;

    grid.innerHTML = items.map(function (item) {
      var image = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '<span>No image</span>';
      return [
        '<article class="recent-product-card">',
        '<a class="recent-product-card__image" href="' + item.url + '">' + image + '</a>',
        '<div class="recent-product-card__body">',
        '<a class="recent-product-card__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>',
        '<div class="recent-product-card__price">' + escapeHtml(item.price) + '</div>',
        '</div>',
        '</article>'
      ].join('');
    }).join('');

    wrap.hidden = false;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[char];
    });
  }

  function updateCartCounts(cart) {
    qsa('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });
  }

  function initBackToTop() {
    var button = qs('[data-back-to-top]');
    if (!button || button.dataset.backToTopReady === 'true') return;
    button.dataset.backToTopReady = 'true';

    var configuredOffset = Number(button.getAttribute('data-show-after')) || 500;
    var ticking = false;

    function update() {
      var header = qs('[data-header]');
      var headerOffset = header ? header.offsetHeight + 120 : 0;
      var offerOpen = document.body.classList.contains('first-order-offer-open');
      var visible = !offerOpen && window.scrollY > Math.max(configuredOffset, headerOffset);
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    button.addEventListener('click', function () {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function initFirstOrderOffer() {
    var offer = qs('[data-first-order-offer]');
    if (!offer || offer.dataset.offerReady === 'true') return;
    offer.dataset.offerReady = 'true';

    var toggle = qs('[data-first-order-offer-toggle]', offer);
    var close = qs('[data-first-order-offer-close]', offer);
    var panel = qs('[data-first-order-offer-panel]', offer);
    var copy = qs('[data-first-order-offer-copy]', offer);
    var status = qs('[data-first-order-offer-status]', offer);
    var code = offer.getAttribute('data-offer-code') || 'WELCOME5';
    var storageKey = offer.getAttribute('data-offer-storage-key') || 'tbd-first-order-offer';
    var copyLabel = copy ? qs('span', copy) : null;
    var originalCopyLabel = copyLabel ? copyLabel.textContent : 'Copy code';
    if (!toggle || !panel) return;

    function setExpanded(expanded, remember) {
      offer.classList.toggle('is-expanded', expanded);
      document.body.classList.toggle('first-order-offer-open', expanded);
      panel.hidden = !expanded;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var backToTop = qs('[data-back-to-top]');
      if (backToTop && expanded) {
        backToTop.classList.remove('is-visible');
        backToTop.setAttribute('aria-hidden', 'true');
        backToTop.tabIndex = -1;
      } else if (backToTop) {
        window.dispatchEvent(new Event('scroll'));
      }
      if (remember) {
        try { localStorage.setItem(storageKey, expanded ? 'expanded' : 'collapsed'); } catch (error) {}
      }
      if (expanded) window.setTimeout(function () {
        var firstControl = qs('button', panel);
        if (firstControl) firstControl.focus();
      }, 0);
    }

    try {
      var savedState = localStorage.getItem(storageKey);
      if (savedState === 'expanded') setExpanded(true, false);
      if (savedState === 'collapsed') setExpanded(false, false);
    } catch (error) {}

    function expandOffer() { setExpanded(true, true); }
    toggle.addEventListener('click', expandOffer);
    toggle.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      expandOffer();
    });
    if (close) close.addEventListener('click', function () {
      setExpanded(false, true);
      toggle.focus();
    });

    if (copy) copy.addEventListener('click', function () {
      function announce() {
        if (copyLabel) copyLabel.textContent = 'Copied';
        if (status) status.textContent = code + ' copied to clipboard';
        window.setTimeout(function () {
          if (copyLabel) copyLabel.textContent = originalCopyLabel;
        }, 2200);
      }

      function announceFailure() {
        if (copyLabel) copyLabel.textContent = 'Copy failed';
        if (status) status.textContent = 'Copy failed. Select and copy the code ' + code + ' manually.';
        window.setTimeout(function () {
          if (copyLabel) copyLabel.textContent = originalCopyLabel;
        }, 3200);
      }

      function copyWithTextarea() {
        var fallback = document.createElement('textarea');
        var copied = false;
        fallback.value = code;
        fallback.setAttribute('readonly', '');
        fallback.setAttribute('aria-hidden', 'true');
        fallback.style.position = 'fixed';
        fallback.style.inset = '0 auto auto -9999px';
        fallback.style.opacity = '0';
        document.body.appendChild(fallback);
        fallback.focus();
        fallback.select();
        fallback.setSelectionRange(0, fallback.value.length);
        try { copied = document.execCommand('copy'); } catch (error) { copied = false; }
        fallback.remove();
        copy.focus();
        if (copied) announce();
        else announceFailure();
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(announce).catch(copyWithTextarea);
        return;
      }
      copyWithTextarea();
    });
    copy.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      copy.click();
    });
  }

  function showCartToast(productTitle) {
    var toast = qs('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('data-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = [
        '<button class="cart-toast__close" type="button" aria-label="Close notification"></button>',
        '<strong data-cart-toast-title>Added to cart</strong>',
        '<span>You can keep shopping or review your order.</span>',
        '<div><a href="/cart">View cart</a><a href="/checkout">Checkout</a></div>'
      ].join('');
      document.body.appendChild(toast);
      qs('.cart-toast__close', toast).addEventListener('click', function () {
        toast.classList.remove('is-visible');
      });
    }

    var title = qs('[data-cart-toast-title]', toast);
    title.textContent = productTitle ? productTitle + ' added to cart' : 'Added to cart';
    window.clearTimeout(toast.hideTimer);
    toast.classList.add('is-visible');
    toast.hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 5200);
  }

  function showUtilityToast(message) {
    var toast = qs('[data-utility-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'utility-toast';
      toast.setAttribute('data-utility-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    window.clearTimeout(toast.hideTimer);
    toast.classList.add('is-visible');
    toast.hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function wishlistProductForButton(button) {
    var scope = button.closest('[data-product-commerce], .product-card');
    var node = scope ? qs('[data-wishlist-product], [data-card-wishlist-product]', scope) : null;
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateWishlistUI() {
    var items = readWishlist();
    var ids = items.map(function (item) { return String(item.id); });
    qsa('[data-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
    qsa('[data-wishlist-toggle]').forEach(function (button) {
      var product = wishlistProductForButton(button);
      var active = product && ids.indexOf(String(product.id)) !== -1;
      button.classList.toggle('is-active', Boolean(active));
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('title', active ? 'Remove from saved products' : 'Save product');
      var label = qs('[data-wishlist-label]', button);
      if (label) label.textContent = active ? 'Remove from saved products' : 'Save product';
    });
  }

  function initWishlist(root) {
    qsa('[data-wishlist-toggle]', root).forEach(function (button) {
      if (button.dataset.wishlistReady === 'true') return;
      button.dataset.wishlistReady = 'true';
      button.addEventListener('click', function () {
        var product = wishlistProductForButton(button);
        if (!product) return;
        var items = readWishlist();
        var index = items.findIndex(function (item) { return String(item.id) === String(product.id); });
        if (index === -1) {
          items.unshift(product);
          showUtilityToast('Saved to your product list');
        } else {
          items.splice(index, 1);
          showUtilityToast('Removed from saved products');
        }
        writeWishlist(items);
        renderWishlist();
      });
    });
    updateWishlistUI();
  }

  function initProductSharing(root) {
    qsa('[data-share-product]', root).forEach(function (button) {
      if (button.dataset.shareReady === 'true') return;
      button.dataset.shareReady = 'true';
      button.addEventListener('click', function () {
        var product = wishlistProductForButton(button);
        var payload = { title: product ? product.title : document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
          return;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.url).then(function () {
            showUtilityToast('Product link copied');
          });
        }
      });
    });
  }

  function initProductRecommendations(root) {
    qsa('[data-product-recommendations]', root).forEach(function (section) {
      if (section.dataset.recommendationsReady === 'true') return;
      section.dataset.recommendationsReady = 'true';

      function loadRecommendations() {
        var url = section.getAttribute('data-url');
        if (!url) return;
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var html = document.createElement('div');
            html.innerHTML = text;
            var remoteSection = qs('[data-product-recommendations]', html);
            var shell = remoteSection ? qs('.product-recommendations-shell', remoteSection) : null;
            if (!shell || shell.getAttribute('data-has-products') !== 'true') return;
            section.innerHTML = remoteSection.innerHTML;
            section.hidden = false;
            initQuickAdd(section);
            initWishlist(section);
          })
          .catch(function () {
            section.hidden = true;
          });
      }

      loadRecommendations();
    });
  }

  function initBrandDirectories(root) {
    qsa('[data-brand-directory]', root).forEach(function (directory) {
      var input = qs('[data-brand-search]', directory);
      if (!input || input.dataset.brandSearchReady === 'true') return;
      input.dataset.brandSearchReady = 'true';
      var cards = qsa('[data-brand-card]', directory);
      var empty = qs('[data-brand-empty]', directory);

      input.addEventListener('input', function () {
        var term = input.value.trim().toLowerCase();
        var visible = 0;
        cards.forEach(function (card) {
          var matches = !term || (card.getAttribute('data-brand-name') || '').indexOf(term) !== -1;
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  function initArticleTools(root) {
    qsa('[data-article-shell]', root).forEach(function (shell) {
      if (shell.dataset.articleReady === 'true') return;
      shell.dataset.articleReady = 'true';

      var body = qs('[data-article-body]', shell);
      var readingProgress = qs('[data-article-reading-progress]', shell);
      var toc = qs('[data-article-toc]', shell);
      var tocList = qs('[data-article-toc-list]', shell);

      if (body && toc && tocList) {
        var headings = qsa('h2', body);
        var usedIds = {};
        var tocItems = headings.map(function (heading, index) {
          var base = heading.id || String(heading.textContent || '')
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '') || 'section-' + (index + 1);
          var nextId = base;
          var duplicate = 1;
          while (usedIds[nextId]) {
            duplicate += 1;
            nextId = base + '-' + duplicate;
          }
          usedIds[nextId] = true;
          heading.id = nextId;
          return '<li><a href="#' + nextId + '">' + escapeHtml(heading.textContent) + '</a></li>';
        });

        if (tocItems.length) {
          tocList.innerHTML = tocItems.join('');
          toc.hidden = false;
          var articleLayout = toc.closest('.article-layout');
          if (articleLayout) articleLayout.classList.add('has-toc');

          if ('IntersectionObserver' in window) {
            var tocLinks = qsa('a', tocList);
            var headingObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                tocLinks.forEach(function (link) {
                  if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
                  else link.removeAttribute('aria-current');
                });
              });
            }, { rootMargin: '-18% 0px -70% 0px' });
            headings.forEach(function (heading) { headingObserver.observe(heading); });
          }
        }
      }

      if (body && readingProgress) {
        var progressTicking = false;
        function updateReadingProgress() {
          var bodyRect = body.getBoundingClientRect();
          var bodyStart = bodyRect.top + window.scrollY;
          var bodyEnd = bodyStart + bodyRect.height;
          var start = bodyStart - window.innerHeight * 0.16;
          var end = bodyEnd - window.innerHeight * 0.72;
          var distance = Math.max(1, end - start);
          var progress = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
          readingProgress.style.setProperty('--article-progress', progress);
          readingProgress.classList.toggle('is-visible', window.scrollY >= start && window.scrollY <= bodyEnd);
          progressTicking = false;
        }
        function requestProgressUpdate() {
          if (progressTicking) return;
          progressTicking = true;
          window.requestAnimationFrame(updateReadingProgress);
        }
        window.addEventListener('scroll', requestProgressUpdate, { passive: true });
        window.addEventListener('resize', requestProgressUpdate);
        updateReadingProgress();
      }

      var shareButton = qs('[data-article-share]', shell);
      if (shareButton) {
        shareButton.addEventListener('click', function () {
          var payload = {
            title: shareButton.getAttribute('data-share-title') || document.title,
            url: shareButton.getAttribute('data-share-url') || window.location.href
          };
          if (navigator.share) {
            navigator.share(payload).catch(function () {});
            return;
          }
          if (navigator.clipboard) {
            navigator.clipboard.writeText(payload.url).then(function () {
              showUtilityToast('Guide link copied');
            });
          }
        });
      }
    });
  }

  function initGlossaryDirectories(root) {
    qsa('[data-glossary-directory]', root).forEach(function (directory) {
      var input = qs('[data-glossary-search]', directory);
      if (!input || input.dataset.glossaryReady === 'true') return;
      input.dataset.glossaryReady = 'true';
      var clear = qs('[data-glossary-clear]', directory);
      var status = qs('[data-glossary-status]', directory);
      var empty = qs('[data-glossary-empty]', directory);
      var items = qsa('.glossary-term-group li', directory);
      var groups = qsa('.glossary-term-group', directory);

      function filterTerms() {
        var term = input.value.trim().toLowerCase();
        var visible = 0;
        items.forEach(function (item) {
          var matches = !term || String(item.textContent || '').toLowerCase().indexOf(term) !== -1;
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        groups.forEach(function (group) {
          group.hidden = qsa('li:not([hidden])', group).length === 0;
        });
        if (clear) clear.hidden = !term;
        if (empty) empty.hidden = visible !== 0;
        if (status) status.textContent = term ? visible + (visible === 1 ? ' matching term' : ' matching terms') : '';
      }

      input.addEventListener('input', filterTerms);
      if (clear) clear.addEventListener('click', function () {
        input.value = '';
        filterTerms();
        input.focus();
      });
    });
  }

  function initKnowledgeQuiz(quiz) {
    var intro = qs('[data-quiz-intro]', quiz);
    var questionsWrap = qs('[data-quiz-questions]', quiz);
    var questions = qsa('[data-quiz-step]', quiz);
    var results = qs('[data-quiz-results]', quiz);
    var start = qs('[data-quiz-start]', quiz);
    var previous = qs('[data-quiz-previous]', quiz);
    var next = qs('[data-quiz-next]', quiz);
    var progressBar = qs('[data-quiz-progress-bar]', quiz);
    var progressTrack = qs('[data-quiz-progress-track]', quiz);
    var progressCurrent = qs('[data-quiz-progress-current]', quiz);
    var share = qs('[data-quiz-share]', quiz);
    var reviewButton = qs('[data-quiz-review]', quiz);
    var restart = qs('[data-quiz-restart]', quiz);
    var status = qs('[data-quiz-status]', quiz);
    var storageKey = quiz.getAttribute('data-quiz-storage-key') || 'tbd-knowledge-quiz';
    var configNode = qs('[data-quiz-config]', quiz);
    if (!questions.length || !intro || !questionsWrap || !results || !next || !configNode) return;

    var config = {};
    try { config = JSON.parse(configNode.textContent || '{}'); } catch (error) { return; }
    var answers = {};
    var current = -1;
    var resetPending = false;
    quiz.classList.add('quiz--enhanced');

    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
      if (saved && saved.contentVersion === config.contentVersion) {
        answers = saved.answers || {};
        current = Number.isInteger(saved.current) ? saved.current : -1;
      }
    } catch (error) {}

    function questionId(index) { return questions[index].getAttribute('data-question-id'); }
    function selected(index) { return qs('input[type="radio"]:checked', questions[index]); }
    function save(complete) {
      try { localStorage.setItem(storageKey, JSON.stringify({ contentVersion: config.contentVersion, current: current, answers: answers, complete: Boolean(complete) })); } catch (error) {}
    }
    function lockQuestion(index, locked) {
      qsa('input[type="radio"]', questions[index]).forEach(function (input) { input.disabled = locked; });
    }
    function renderFeedback(index) {
      var question = questions[index];
      var answer = answers[questionId(index)];
      var feedback = qs('[data-question-feedback]', question);
      if (!feedback) return;
      feedback.innerHTML = '';
      if (!answer || !answer.checked) { feedback.hidden = true; return; }
      var correct = question.getAttribute('data-correct-choice');
      var heading = document.createElement('p');
      var explanation = document.createElement('p');
      var nextStep = document.createElement('p');
      var sources = document.createElement('p');
      heading.className = answer.choice === correct ? 'is-correct' : 'is-review';
      heading.innerHTML = '<strong>' + (answer.choice === correct ? 'Best answer selected.' : 'Best answer: ' + escapeHtml(correct) + '.') + '</strong>';
      explanation.textContent = qs('[data-feedback-copy]', question)?.textContent || '';
      nextStep.innerHTML = '<strong>What to do next:</strong> ' + escapeHtml(qs('[data-next-step-copy]', question)?.textContent || '');
      sources.innerHTML = '<strong>Sources:</strong> ' + (qs('[data-source-links]', question)?.innerHTML || '');
      feedback.appendChild(heading);
      feedback.appendChild(explanation);
      feedback.appendChild(nextStep);
      feedback.appendChild(sources);
      feedback.hidden = false;
    }
    function setButtonLabel(label) {
      var labelNode = qs('span', next);
      if (labelNode) labelNode.textContent = label;
    }
    function showStep(index, focusStep) {
      current = Math.max(0, Math.min(questions.length - 1, index));
      intro.hidden = true;
      questionsWrap.hidden = false;
      results.hidden = true;
      questions.forEach(function (question, questionIndex) { question.hidden = questionIndex !== current; });
      var answer = answers[questionId(current)];
      if (previous) previous.disabled = current === 0;
      next.disabled = !selected(current) && !answer;
      lockQuestion(current, Boolean(answer?.checked));
      renderFeedback(current);
      setButtonLabel(answer?.checked ? (current === questions.length - 1 ? next.getAttribute('data-result-label') : next.getAttribute('data-next-label')) : next.getAttribute('data-check-label'));
      if (progressCurrent) progressCurrent.textContent = current + 1;
      if (progressBar) progressBar.style.setProperty('--quiz-progress', (current + 1) / questions.length);
      if (progressTrack) progressTrack.setAttribute('aria-valuenow', current + 1);
      save(false);
      if (focusStep) {
        var legend = qs('legend', questions[current]);
        if (legend) { legend.tabIndex = -1; legend.focus(); }
      }
    }
    function dimensionLabel(id) {
      return (config.dimensions || []).find(function (dimension) { return dimension.id === id; })?.label || id;
    }
    function showResults() {
      var scores = {};
      var total = 0;
      Object.values(answers).forEach(function (answer) {
        if (answer.correct) { total += 1; scores[answer.dimension] = (scores[answer.dimension] || 0) + 1; }
      });
      intro.hidden = true;
      questionsWrap.hidden = true;
      results.hidden = false;
      var totalNode = qs('[data-quiz-total-score]', results);
      if (totalNode) totalNode.textContent = total;
      var band = (config.resultBands || []).find(function (item) { return total >= item.minimum && total <= item.maximum; }) || {};
      var bandTitle = qs('[data-quiz-band-title]', results);
      var bandCopy = qs('[data-quiz-band-copy]', results);
      var bandLink = qs('[data-quiz-band-link]', results);
      if (bandTitle) bandTitle.textContent = band.label || 'Your result';
      if (bandCopy) bandCopy.textContent = band.body || '';
      if (bandLink) { bandLink.textContent = band.ctaLabel || 'Browse Tool Guides'; bandLink.href = band.ctaUrl || '/blogs/tool-guides'; }
      (config.dimensions || []).forEach(function (dimension) {
        var card = qs('[data-quiz-dimension="' + dimension.id + '"]', results);
        if (!card) return;
        var score = scores[dimension.id] || 0;
        var scoreNode = qs('[data-quiz-dimension-score]', card);
        var copyNode = qs('[data-quiz-dimension-copy]', card);
        if (scoreNode) scoreNode.textContent = score;
        var threshold = dimension.maximum === 4 ? (score <= 1 ? 'Review recommended' : score === 2 ? 'Developing in these scenarios' : 'Strong in these scenarios') : (score <= 2 ? 'Review recommended' : score === 3 ? 'Developing in these scenarios' : 'Strong in these scenarios');
        if (copyNode) copyNode.textContent = threshold;
      });
      var safety = scores.safety || 0;
      var safetyNode = qs('[data-quiz-safety-notice]', results);
      if (safetyNode) safetyNode.textContent = safety <= 2 ? config.safetyNotices.low : safety === 3 ? config.safetyNotices.developing : config.safetyNotices.strong;
      var answerReview = qs('[data-quiz-answer-review]', results);
      if (answerReview) {
        answerReview.innerHTML = '';
        questions.forEach(function (question, index) {
          var answer = answers[questionId(index)];
          if (!answer) return;
          var item = document.createElement('li');
          item.textContent = 'Question ' + (index + 1) + ': ' + answer.choice + (answer.correct ? ' (best answer)' : ' (review the explanation)');
          answerReview.appendChild(item);
        });
      }
      save(true);
      var heading = qs('h2', results);
      if (heading) { heading.tabIndex = -1; heading.focus(); }
    }

    questions.forEach(function (question, index) {
      var id = questionId(index);
      var savedAnswer = answers[id];
      qsa('input[type="radio"]', question).forEach(function (input) {
        if (savedAnswer?.choice === input.value) input.checked = true;
        input.addEventListener('change', function () {
          answers[id] = { choice: input.value, dimension: question.getAttribute('data-dimension'), checked: false, correct: input.value === question.getAttribute('data-correct-choice') };
          next.disabled = false;
          setButtonLabel(next.getAttribute('data-check-label'));
          save(false);
        });
      });
      if (savedAnswer?.checked) { lockQuestion(index, true); renderFeedback(index); }
    });
    if (start) start.addEventListener('click', function () { showStep(current >= 0 ? current : 0, true); });
    if (previous) previous.addEventListener('click', function () { showStep(current - 1, true); });
    next.addEventListener('click', function () {
      var input = selected(current);
      var id = questionId(current);
      if (!input || !answers[id]) return;
      if (!answers[id].checked) {
        answers[id].checked = true;
        lockQuestion(current, true);
        renderFeedback(current);
        setButtonLabel(current === questions.length - 1 ? next.getAttribute('data-result-label') : next.getAttribute('data-next-label'));
        save(false);
        var feedback = qs('[data-question-feedback]', questions[current]);
        if (feedback) feedback.focus();
      } else if (current === questions.length - 1) showResults();
      else showStep(current + 1, true);
    });
    if (reviewButton) reviewButton.addEventListener('click', function () { showStep(0, true); });
    if (share) share.addEventListener('click', function () {
      var total = Object.values(answers).filter(function (answer) { return answer.correct; }).length;
      var dimensions = (config.dimensions || []).map(function (dimension) {
        var score = Object.values(answers).filter(function (answer) { return answer.dimension === dimension.id && answer.correct; }).length;
        return { id: dimension.id, label: dimension.label, ratio: score / dimension.maximum };
      }).sort(function (a, b) { return b.ratio - a.ratio; });
      var text = 'I scored ' + total + '/24 on ToolBestDiscount\'s Woodworking Judgment Check. My strongest area was ' + dimensionLabel(dimensions[0]?.id) + '; my next focus is ' + dimensionLabel(dimensions[dimensions.length - 1]?.id) + '.';
      var payload = { title: quiz.getAttribute('data-quiz-share-title') || document.title, text: text, url: window.location.href.split('?')[0] };
      if (navigator.share) navigator.share(payload).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(payload.text + ' ' + payload.url).then(function () { if (status) status.textContent = 'Result link copied'; });
    });
    if (restart) restart.addEventListener('click', function () {
      if (!resetPending) {
        resetPending = true;
        restart.textContent = restart.getAttribute('data-confirm-label') || 'Confirm reset';
        window.setTimeout(function () { resetPending = false; restart.textContent = 'Start over'; }, 4000);
        return;
      }
      answers = {};
      current = -1;
      resetPending = false;
      questions.forEach(function (question) { qsa('input[type="radio"]', question).forEach(function (input) { input.checked = false; input.disabled = false; }); });
      try { localStorage.removeItem(storageKey); } catch (error) {}
      results.hidden = true;
      questionsWrap.hidden = true;
      intro.hidden = false;
      restart.textContent = 'Start over';
      if (start) start.focus();
    });

    var complete = questions.every(function (question) { return answers[question.getAttribute('data-question-id')]?.checked; });
    if (complete) showResults();
    else if (current >= 0 && Object.keys(answers).length) showStep(current, false);
    else { questionsWrap.hidden = true; results.hidden = true; intro.hidden = false; }
  }

  function ensureQuizButtonKeyboard(quiz) {
    qsa('button', quiz).forEach(function (button) {
      if (button.dataset.quizKeyboardReady === 'true') return;
      button.dataset.quizKeyboardReady = 'true';
      button.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !button.disabled) {
          event.preventDefault();
          button.click();
        }
      });
    });
  }

  function initQuizzes(root) {
    qsa('[data-quiz]', root).forEach(function (quiz) {
      if (quiz.dataset.quizReady === 'true') return;
      quiz.dataset.quizReady = 'true';
      ensureQuizButtonKeyboard(quiz);
      if (quiz.getAttribute('data-quiz-mode') === 'knowledge') {
        initKnowledgeQuiz(quiz);
        return;
      }
      var intro = qs('[data-quiz-intro]', quiz);
      var questionsWrap = qs('[data-quiz-questions]', quiz);
      var questions = qsa('[data-quiz-step]', quiz);
      var results = qs('[data-quiz-results]', quiz);
      var start = qs('[data-quiz-start]', quiz);
      var previous = qs('[data-quiz-previous]', quiz);
      var next = qs('[data-quiz-next]', quiz);
      var progressBar = qs('[data-quiz-progress-bar]', quiz);
      var progressCurrent = qs('[data-quiz-progress-current]', quiz);
      var review = qs('[data-quiz-answer-review]', quiz);
      var share = qs('[data-quiz-share]', quiz);
      var restart = qs('[data-quiz-restart]', quiz);
      var status = qs('[data-quiz-status]', quiz);
      var storageKey = quiz.getAttribute('data-quiz-storage-key') || 'tbd-quiz-progress';
      if (!questions.length || !intro || !questionsWrap || !results || !next) return;

      var answers = {};
      var current = -1;
      var completed = false;
      quiz.classList.add('quiz--enhanced');

      try {
        var saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
        if (saved && saved.answers) answers = saved.answers;
        if (saved && Number.isInteger(saved.current)) current = Math.max(0, Math.min(questions.length - 1, saved.current));
        completed = Boolean(saved && saved.complete);
      } catch (error) {}

      function selectedInput(index) {
        return qs('input[type="radio"]:checked', questions[index]);
      }

      function saveProgress() {
        try { localStorage.setItem(storageKey, JSON.stringify({ current: current, answers: answers })); } catch (error) {}
      }

      function updateQuestionExplanation(index) {
        var input = selectedInput(index);
        var explanation = qs('[data-question-explanation]', questions[index]);
        if (!explanation) return;
        explanation.textContent = input ? (input.getAttribute('data-option-explanation') || '') : '';
        explanation.hidden = !explanation.textContent;
      }

      function showStep(index, focusStep) {
        current = Math.max(0, Math.min(questions.length - 1, index));
        intro.hidden = true;
        questionsWrap.hidden = false;
        results.hidden = true;
        questions.forEach(function (question, questionIndex) { question.hidden = questionIndex !== current; });
        if (previous) previous.disabled = current === 0;
        next.disabled = !selectedInput(current);
        var nextLabel = qs('span', next);
        if (nextLabel) nextLabel.textContent = current === questions.length - 1
          ? next.getAttribute('data-result-label')
          : next.getAttribute('data-next-label');
        if (progressCurrent) progressCurrent.textContent = current + 1;
        if (progressBar) progressBar.style.setProperty('--quiz-progress', (current + 1) / questions.length);
        var progressTrack = qs('[data-quiz-progress-track]', quiz);
        if (progressTrack) progressTrack.setAttribute('aria-valuenow', current + 1);
        updateQuestionExplanation(current);
        saveProgress();
        if (focusStep) {
          var legend = qs('legend', questions[current]);
          if (legend) {
            legend.tabIndex = -1;
            legend.focus();
          }
        }
      }

      function showResults() {
        intro.hidden = true;
        questionsWrap.hidden = true;
        results.hidden = false;
        var scores = {};
        Object.keys(answers).forEach(function (index) {
          var key = answers[index].key || '';
          if (key) scores[key] = (scores[key] || 0) + 1;
        });
        var highest = -1;
        qsa('[data-quiz-result-key]', results).forEach(function (card) {
          var key = card.getAttribute('data-quiz-result-key') || '';
          var score = scores[key] || 0;
          var scoreNode = qs('[data-quiz-result-score]', card);
          if (scoreNode) scoreNode.textContent = score;
          card.classList.remove('is-primary');
          if (score > highest) highest = score;
        });
        if (highest > 0) qsa('[data-quiz-result-key]', results).forEach(function (card) {
          var key = card.getAttribute('data-quiz-result-key') || '';
          card.classList.toggle('is-primary', (scores[key] || 0) === highest);
        });
        if (review) {
          review.innerHTML = '';
          questions.forEach(function (question, index) {
            var answer = answers[index];
            if (!answer) return;
            var item = document.createElement('li');
            var heading = document.createElement('strong');
            var explanation = document.createElement('p');
            heading.textContent = answer.question + ': ' + answer.label;
            explanation.textContent = answer.explanation;
            item.appendChild(heading);
            if (answer.explanation) item.appendChild(explanation);
            review.appendChild(item);
          });
        }
        try { localStorage.setItem(storageKey, JSON.stringify({ current: current, answers: answers, complete: true })); } catch (error) {}
        var resultHeading = qs('h2', results);
        if (resultHeading) {
          resultHeading.tabIndex = -1;
          resultHeading.focus();
        }
      }

      questions.forEach(function (question, index) {
        var savedAnswer = answers[index];
        qsa('input[type="radio"]', question).forEach(function (input) {
          if (savedAnswer && savedAnswer.key === input.value) input.checked = true;
          input.addEventListener('change', function () {
            answers[index] = {
              key: input.value,
              label: input.getAttribute('data-option-label') || input.value,
              explanation: input.getAttribute('data-option-explanation') || '',
              question: String(qs('legend', question).textContent || '').replace(/^Question\s+\d+/, '').trim()
            };
            next.disabled = false;
            updateQuestionExplanation(index);
            saveProgress();
          });
        });
      });

      if (start) start.addEventListener('click', function () { showStep(0, true); });
      if (previous) previous.addEventListener('click', function () { showStep(current - 1, true); });
      next.addEventListener('click', function () {
        if (!selectedInput(current)) return;
        if (current === questions.length - 1) showResults();
        else showStep(current + 1, true);
      });

      if (share) share.addEventListener('click', function () {
        var primary = qs('.quiz-result-card.is-primary h3', results);
        var shareTitle = quiz.getAttribute('data-quiz-share-title') || document.title;
        var shareText = primary ? shareTitle + ': ' + primary.textContent : shareTitle;
        var payload = { title: shareTitle, text: shareText, url: window.location.href.split('?')[0] };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.text + ' ' + payload.url).then(function () {
            if (status) status.textContent = 'Result link copied';
          });
        }
      });

      if (restart) restart.addEventListener('click', function () {
        answers = {};
        current = -1;
        questions.forEach(function (question) {
          qsa('input[type="radio"]', question).forEach(function (input) { input.checked = false; });
        });
        try { localStorage.removeItem(storageKey); } catch (error) {}
        results.hidden = true;
        questionsWrap.hidden = true;
        intro.hidden = false;
        if (start) start.focus();
      });

      if (completed && Object.keys(answers).length) showResults();
      else if (Object.keys(answers).length && current >= 0) showStep(current, false);
      else {
        questionsWrap.hidden = true;
        results.hidden = true;
        intro.hidden = false;
      }
    });
  }

  function wishlistCardMarkup(item) {
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : '<span class="wishlist-card__placeholder">No image</span>';
    var compare = item.compareAtPrice > item.price
      ? '<s>' + formatMoney(item.compareAtPrice, item.currency) + '</s>'
      : '';
    var action = item.available && item.hasOnlyDefaultVariant
      ? '<form method="post" action="/cart/add" class="quick-add-form" data-product-title="' + escapeHtml(item.title) + '"><input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '"><input type="hidden" name="quantity" value="1"><button class="button primary full" type="submit">Add to cart</button></form>'
      : '<a class="button secondary full" href="' + escapeHtml(item.url) + '">' + (item.available ? 'Choose options' : 'View product') + '</a>';
    return [
      '<article class="wishlist-card" data-wishlist-item="' + escapeHtml(item.id) + '">',
      '<button class="wishlist-card__remove" type="button" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">×</button>',
      '<a class="wishlist-card__image" href="' + escapeHtml(item.url) + '">' + image + '</a>',
      '<div class="wishlist-card__body">',
      '<a class="wishlist-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>',
      '<div class="wishlist-card__price"><strong>' + formatMoney(item.price, item.currency) + '</strong>' + compare + '</div>',
      '<span class="stock ' + (item.available ? 'in-stock' : 'out-stock') + '">' + (item.available ? 'In stock' : 'Check availability') + '</span>',
      action,
      '</div></article>'
    ].join('');
  }

  function renderWishlist() {
    var grid = qs('[data-wishlist-grid]');
    var empty = qs('[data-wishlist-empty]');
    var count = qs('[data-wishlist-page-count]');
    if (!grid) return;
    var items = readWishlist();
    grid.innerHTML = items.map(wishlistCardMarkup).join('');
    if (empty) empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    if (count) count.textContent = items.length + (items.length === 1 ? ' product' : ' products');
    qsa('[data-wishlist-remove]', grid).forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-wishlist-remove');
        writeWishlist(readWishlist().filter(function (item) { return String(item.id) !== String(id); }));
        renderWishlist();
      });
    });
    initQuickAdd(grid);
  }

  function initMenu() {
    var toggle = qs('[data-menu-toggle]');
    var menu = qs('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }

  function initCategoryFlyouts() {
    qsa('[data-category-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.hero-cat-item');
        if (!item) return;
        qsa('.hero-cat-item.is-open').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
        item.classList.toggle('is-open');
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.hero-category-menu')) return;
      qsa('.hero-cat-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    });
  }

  function initCountdown() {
    qsa('[data-countdown]').forEach(function (node) {
      var end = new Date(node.getAttribute('data-countdown-end')).getTime();
      if (!end) return;

      function render() {
        var remaining = Math.max(0, end - Date.now());
        var days = Math.floor(remaining / 86400000);
        var hours = Math.floor((remaining % 86400000) / 3600000);
        var minutes = Math.floor((remaining % 3600000) / 60000);
        qs('[data-days]', node).textContent = String(days).padStart(2, '0');
        qs('[data-hours]', node).textContent = String(hours).padStart(2, '0');
        qs('[data-minutes]', node).textContent = String(minutes).padStart(2, '0');
      }

      render();
      setInterval(render, 60000);
    });
  }

  function initPredictiveSearch() {
    var input = qs('[data-predictive-input]');
    var panel = qs('[data-predictive-panel]');
    if (!input || !panel) return;

    var form = input.closest('form');
    var scope = form ? qs('[data-search-scope]', form) : null;
    var shortcutsNode = qs('[data-search-shortcuts]');
    var shortcuts = [];
    if (shortcutsNode) {
      try {
        shortcuts = JSON.parse(shortcutsNode.textContent || '[]');
      } catch (error) {
        shortcuts = [];
      }
    }

    var timer = null;

    function syncScopeWidth() {
      if (!form || !scope) return;

      var styles = window.getComputedStyle(scope);
      var probe = document.createElement('span');
      var widestLabel = 0;
      probe.setAttribute('aria-hidden', 'true');
      probe.style.position = 'fixed';
      probe.style.left = '-9999px';
      probe.style.visibility = 'hidden';
      probe.style.whiteSpace = 'nowrap';
      probe.style.font = styles.font;
      probe.style.fontWeight = styles.fontWeight;
      document.body.appendChild(probe);

      Array.prototype.forEach.call(scope.options, function (option) {
        probe.textContent = option.textContent.trim();
        widestLabel = Math.max(widestLabel, probe.getBoundingClientRect().width);
      });

      probe.remove();

      var compact = window.matchMedia('(max-width: 640px)').matches;
      var minimum = compact ? 74 : 82;
      var maximum = compact ? 156 : 176;
      var arrowAndPadding = compact ? 46 : 52;
      var width = Math.min(maximum, Math.max(minimum, Math.ceil(widestLabel + arrowAndPadding)));

      form.style.setProperty('--search-scope-width', width + 'px');
      scope.title = scope.options[scope.selectedIndex].textContent.trim();
    }

    syncScopeWidth();
    window.addEventListener('resize', syncScopeWidth);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncScopeWidth);
    }
    if (scope) {
      scope.addEventListener('change', function () {
        scope.title = scope.options[scope.selectedIndex].textContent.trim();
      });
    }

    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function renderGroup(label, items) {
      if (!items.length) return '';
      return '<div class="predictive-group"><strong class="predictive-group__heading">' + label + '</strong>' + items.join('') + '</div>';
    }

    function renderTextResult(item, typeLabel) {
      return [
        '<a class="predictive-item predictive-item--text" href="' + escapeHtml(item.url || '#') + '">',
        '<span class="predictive-item__type">' + typeLabel + '</span>',
        '<span><strong>' + escapeHtml(item.title || '') + '</strong></span>',
        '</a>'
      ].join('');
    }

    function matchingShortcuts(term) {
      var words = term.toLowerCase().split(/\s+/).filter(Boolean);
      var seen = {};
      return shortcuts.filter(function (item) {
        var haystack = ((item.title || '') + ' ' + (item.keywords || '')).toLowerCase();
        var matches = words.every(function (word) { return haystack.indexOf(word) !== -1; });
        if (!matches || !item.url || seen[item.url]) return false;
        seen[item.url] = true;
        return true;
      }).slice(0, 4);
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        closePanel();
        panel.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        var selectedTypes = scope ? scope.value : 'product,page,article';
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=' + encodeURIComponent(selectedTypes) + '&resources[limit]=4';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (payload) {
            var results = payload.resources && payload.resources.results ? payload.resources.results : {};
            var products = results.products || [];
            var pages = results.pages || [];
            var articles = results.articles || [];
            var quickLinks = selectedTypes === 'product' ? [] : matchingShortcuts(term);

            var productMarkup = products.map(function (product) {
              var image = product.image
                ? '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '">'
                : '<span class="predictive-item__placeholder"></span>';
              return [
                '<a class="predictive-item" href="' + product.url + '">',
                image,
                '<span><strong>' + escapeHtml(product.title) + '</strong><br><small>' + escapeHtml(product.price || '') + '</small></span>',
                '</a>'
              ].join('');
            });

            var pageMarkup = pages.map(function (page) { return renderTextResult(page, 'PAGE'); });
            var articleMarkup = articles.map(function (article) { return renderTextResult(article, 'GUIDE'); });
            var shortcutMarkup = quickLinks.map(function (item) { return renderTextResult(item, 'LINK'); });
            var allResultsUrl = '/search?q=' + encodeURIComponent(term) + '&type=' + encodeURIComponent(selectedTypes) + '&options%5Bprefix%5D=last';
            var markup = [
              renderGroup('Products', productMarkup),
              renderGroup('Guides', articleMarkup),
              renderGroup('Pages', pageMarkup),
              renderGroup('Store links', shortcutMarkup)
            ].join('');

            if (!markup) markup = '<p class="predictive-empty">No matching products, guides, or pages yet.</p>';
            panel.innerHTML = markup + '<a class="predictive-all" href="' + allResultsUrl + '">View all results for “' + escapeHtml(term) + '”</a>';
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {
            closePanel();
          });
      }, 180);
    });

    if (scope) scope.addEventListener('change', function () { input.dispatchEvent(new Event('input')); });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });

    document.addEventListener('click', function (event) {
      if (!panel.contains(event.target) && event.target !== input) {
        closePanel();
      }
    });
  }

  function initVariantForms(root) {
    qsa('.product-form', root).forEach(function (form) {
      if (form.dataset.variantReady === 'true') return;
      var variantsNode = qs('[data-product-variants]', form);
      var variantInput = qs('[data-variant-id]', form);
      var addButton = qs('[data-add-to-cart]', form);
      var selects = qsa('[data-variant-selects] select', form);
      var productCommerce = form.closest('[data-product-commerce]');
      var priceRequired = productCommerce && productCommerce.getAttribute('data-price-required') === 'true';
      if (!variantsNode || !variantInput || !addButton || !selects.length) return;
      form.dataset.variantReady = 'true';

      var variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        return;
      }

      function updateVariant() {
        var selected = selects.map(function (select) {
          return select.value;
        });
        var matched = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });

        if (!matched) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
          return;
        }

        variantInput.value = matched.id;
        addButton.disabled = priceRequired || !matched.available;
        addButton.textContent = priceRequired ? productCommerce.getAttribute('data-draft-button-label') : (matched.available ? 'Add to cart' : 'Sold out');

        qsa('[data-sticky-variant]').forEach(function (input) {
          input.value = matched.id;
        });
        qsa('[data-sticky-add]').forEach(function (button) {
          button.disabled = !matched.available;
          var label = qs('[data-sticky-label]', button);
          if (label) label.textContent = matched.available ? 'Add to cart' : 'Sold out';
        });
        qsa('[data-sticky-price]').forEach(function (price) {
          var currency = price.getAttribute('data-currency-code') || 'USD';
          price.textContent = priceRequired ? productCommerce.getAttribute('data-price-pending-label') : formatMoney(matched.price, currency);
        });

        var currencyNode = qs('[data-currency-code]', form);
        var currency = currencyNode ? currencyNode.getAttribute('data-currency-code') : 'USD';
        qsa('[data-product-current-price], [data-purchase-price]', form).forEach(function (price) {
          price.textContent = priceRequired ? productCommerce.getAttribute('data-price-pending-label') : formatMoney(matched.price, currency);
        });
        var compare = qs('[data-product-compare-price]', form);
        var savingBadge = qs('[data-saving-percent]', form);
        var savingLine = qs('[data-saving-line]', form);
        var savingAmount = qs('[data-saving-amount]', form);
        var hasSaving = !priceRequired && matched.compare_at_price && matched.compare_at_price > matched.price;
        if (compare) {
          compare.hidden = !hasSaving;
          compare.textContent = hasSaving ? formatMoney(matched.compare_at_price, currency) : '';
        }
        if (savingBadge) {
          savingBadge.hidden = !hasSaving;
          savingBadge.textContent = hasSaving ? 'Save ' + Math.round((matched.compare_at_price - matched.price) * 100 / matched.compare_at_price) + '%' : '';
        }
        if (savingLine) savingLine.hidden = !hasSaving;
        if (savingAmount) savingAmount.textContent = hasSaving ? formatMoney(matched.compare_at_price - matched.price, currency) : '';
        var sku = qs('[data-current-sku]', form);
        if (sku) sku.textContent = matched.sku ? 'SKU: ' + matched.sku : '';
        var stock = qs('[data-stock-label]', form);
        if (stock) {
          stock.textContent = priceRequired ? productCommerce.getAttribute('data-draft-status-label') : (matched.available ? 'In stock and ready to order' : 'This option is sold out');
          stock.classList.toggle('in-stock', !priceRequired && matched.available);
          stock.classList.toggle('out-stock', priceRequired || !matched.available);
        }
        selects.forEach(function (select) {
          var optionLabel = form.querySelector('label[for="' + select.id + '"] span');
          if (optionLabel) optionLabel.textContent = select.value;
        });

        var wishlistNode = qs('[data-wishlist-product]');
        if (wishlistNode) {
          try {
            var wishlistProduct = JSON.parse(wishlistNode.textContent);
            wishlistProduct.variantId = matched.id;
            wishlistProduct.price = matched.price;
            wishlistProduct.compareAtPrice = matched.compare_at_price || 0;
            wishlistProduct.available = matched.available;
            wishlistNode.textContent = JSON.stringify(wishlistProduct);
            var saved = readWishlist();
            var savedIndex = saved.findIndex(function (item) { return String(item.id) === String(wishlistProduct.id); });
            if (savedIndex !== -1) {
              saved[savedIndex] = wishlistProduct;
              writeWishlist(saved);
            }
          } catch (error) {}
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (select) {
        select.addEventListener('change', updateVariant);
      });
    });
  }

  function initProductTabs(root) {
    qsa('[data-product-tabs]', root).forEach(function (tabs) {
      qsa('[data-product-tab]', tabs).forEach(function (button) {
        if (button.dataset.tabReady === 'true') return;
        button.dataset.tabReady = 'true';
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-product-tab');
          qsa('[data-product-tab]', tabs).forEach(function (tab) {
            var active = tab === button;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          qsa('[data-product-panel]', tabs).forEach(function (panel) {
            var active = panel.getAttribute('data-product-panel') === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  function initCollectionFilters(root) {
    qsa('[data-collection-page]', root).forEach(function (page) {
      var toggle = qs('[data-filter-toggle]', page);
      var filters = qs('[data-collection-filters]', page);
      var close = qs('[data-filter-close]', page);
      if (!toggle || !filters || toggle.dataset.filterReady === 'true') return;
      toggle.dataset.filterReady = 'true';

      function setOpen(open) {
        filters.classList.toggle('is-open', open);
        document.body.classList.toggle('filters-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () { setOpen(true); });
      if (close) close.addEventListener('click', function () { setOpen(false); });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setOpen(false);
      });
    });
  }

  function initProductGalleries(root) {
    qsa('[data-product-gallery]', root).forEach(function (gallery) {
      var main = qs('[data-gallery-main]', gallery);
      if (!main) return;
      qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        if (thumb.dataset.galleryReady === 'true') return;
        thumb.dataset.galleryReady = 'true';
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-gallery-src');
          main.alt = thumb.getAttribute('data-gallery-alt') || '';
          qsa('[data-gallery-thumb]', gallery).forEach(function (item) {
            item.classList.toggle('is-active', item === thumb);
          });
        });
      });
    });
  }

  function initQuickAdd(root) {
    qsa('.quick-add-form', root).forEach(function (form) {
      if (form.dataset.quickAddReady === 'true') return;
      form.dataset.quickAddReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = qs('button[type="submit"]', form);
        if (!button || button.disabled) return;
        var isIconButton = button.classList.contains('product-cart-fab');
        var originalText = button.textContent;
        var originalLabel = button.getAttribute('aria-label');
        button.disabled = true;
        if (isIconButton) {
          button.classList.add('is-loading');
          button.setAttribute('aria-label', 'Adding to cart');
        } else {
          button.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add item');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCartCounts(cart);
            showCartToast(form.getAttribute('data-product-title'));
            if (isIconButton) button.setAttribute('aria-label', 'Added to cart');
            else button.textContent = 'Added to cart';
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            setTimeout(function () {
              button.disabled = false;
              if (isIconButton) button.setAttribute('aria-label', originalLabel || 'Add to cart');
              else button.textContent = originalText;
              button.classList.remove('is-added');
            }, 1800);
          })
          .catch(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.classList.add('is-error');
            if (isIconButton) button.setAttribute('aria-label', 'Unable to add. Try again');
            else button.textContent = 'Try again';
            setTimeout(function () {
              if (isIconButton) button.setAttribute('aria-label', originalLabel || 'Add to cart');
              else button.textContent = originalText;
              button.classList.remove('is-error');
            }, 1800);
          });
      });
    });
  }

  function initProductAdd(root) {
    qsa('[data-product-form]', root).forEach(function (form) {
      if (form.dataset.productAddReady === 'true') return;
      form.dataset.productAddReady = 'true';
      form.addEventListener('submit', function (event) {
        var button = event.submitter || qs('[data-add-to-cart]', form);
        if (!button || !button.matches('[data-add-to-cart]') || button.disabled) return;
        event.preventDefault();
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add item');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCartCounts(cart);
            showCartToast(form.getAttribute('data-product-title'));
            button.textContent = 'Added to cart';
            button.classList.add('is-added');
            window.setTimeout(function () {
              button.disabled = false;
              button.textContent = originalText;
              button.classList.remove('is-added');
            }, 1800);
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Try again';
            button.classList.add('is-error');
            window.setTimeout(function () {
              button.textContent = originalText;
              button.classList.remove('is-error');
            }, 1800);
          });
      });
    });
  }

  function initStickyBuy(root) {
    qsa('[data-sticky-buy]', root).forEach(function (bar) {
      if (bar.dataset.stickyReady === 'true') return;
      var primaryAdd = qs('[data-add-to-cart]');
      if (!primaryAdd) return;
      bar.dataset.stickyReady = 'true';

      function update() {
        var mobile = window.matchMedia('(max-width: 700px)').matches;
        bar.classList.toggle('is-visible', mobile || primaryAdd.getBoundingClientRect().bottom < 0);
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initHeroSliders(root) {
    qsa('[data-hero-slider]', root).forEach(function (slider) {
      if (slider.dataset.heroReady === 'true') return;
      slider.dataset.heroReady = 'true';
      var slides = qsa('[data-hero-slide]', slider);
      var dots = qsa('[data-hero-dot]', slider);
      var previous = qs('[data-hero-prev]', slider);
      var next = qs('[data-hero-next]', slider);
      var current = 0;
      var interval = null;
      var seconds = Number(slider.getAttribute('data-autoplay') || 0);
      if (slides.length < 2) return;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === current;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === current);
        });
      }

      function restart() {
        if (interval) window.clearInterval(interval);
        if (seconds > 0) interval = window.setInterval(function () { show(current + 1); }, seconds * 1000);
      }

      if (previous) previous.addEventListener('click', function () { show(current - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(Number(dot.getAttribute('data-hero-dot'))); restart(); });
      });
      slider.addEventListener('mouseenter', function () { if (interval) window.clearInterval(interval); });
      slider.addEventListener('mouseleave', restart);
      restart();
    });
  }

  function initQuantitySteppers(root) {
    qsa('[data-quantity-stepper]', root).forEach(function (stepper) {
      if (stepper.dataset.quantityReady === 'true') return;
      stepper.dataset.quantityReady = 'true';
      var input = qs('input[type="number"]', stepper);
      if (!input) return;
      qsa('[data-quantity-change]', stepper).forEach(function (button) {
        button.addEventListener('click', function () {
          var minimum = Number(input.min || 0);
          var nextValue = Number(input.value || 0) + Number(button.getAttribute('data-quantity-change') || 0);
          input.value = Math.max(minimum, nextValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initToolsInAction(root) {
    qsa('[data-tools-in-action]', root).forEach(function (section) {
      if (section.dataset.toolsActionReady === 'true') return;
      section.dataset.toolsActionReady = 'true';

      var track = qs('[data-tools-video-track]', section);
      if (!track) return;
      var cards = qsa('[data-tools-video-card]', track);
      var previous = qs('[data-tools-video-prev]', section);
      var next = qs('[data-tools-video-next]', section);

      if (section.hasAttribute('data-tools-random')) {
        var visibleCount = Math.max(1, Number(section.getAttribute('data-visible-count')) || cards.length);
        cards.sort(function () { return Math.random() - 0.5; });
        cards.forEach(function (card, index) {
          card.hidden = index >= visibleCount;
          track.appendChild(card);
        });
        cards = cards.slice(0, visibleCount);
      }

      function scrollAmount() {
        var firstCard = cards[0];
        if (!firstCard) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        return firstCard.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 16);
      }

      function updateControls() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        if (previous) {
          previous.hidden = !hasOverflow;
          previous.disabled = track.scrollLeft <= 2;
        }
        if (next) {
          next.hidden = !hasOverflow;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }

      if (previous) previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);

      var videoButtons = qsa('[data-tools-video-load]', section);

      function loadVideoPoster(button) {
        if (button.dataset.posterRequested === 'true') return;
        button.dataset.posterRequested = 'true';

        var videoUrl = button.getAttribute('data-video-url') || '';
        var poster = qs('[data-tools-video-poster]', button);
        if (!poster || !/^https:\/\/www\.tiktok\.com\/@[^/]+\/video\/\d+/.test(videoUrl) || !window.fetch) return;

        window.fetch('https://www.tiktok.com/oembed?url=' + encodeURIComponent(videoUrl), {
          credentials: 'omit',
          referrerPolicy: 'strict-origin-when-cross-origin'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('TikTok poster unavailable');
            return response.json();
          })
          .then(function (data) {
            if (!data || !/^https:\/\//.test(data.thumbnail_url || '')) return;
            function revealPoster() {
              if (!poster.naturalWidth) return;
              poster.hidden = false;
              button.classList.add('has-video-poster');
            }
            poster.addEventListener('load', revealPoster, { once: true });
            poster.src = data.thumbnail_url;
            if (poster.complete) revealPoster();
          })
          .catch(function () {
            button.classList.add('has-poster-error');
          });
      }

      if ('IntersectionObserver' in window) {
        var posterObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadVideoPoster(entry.target);
            posterObserver.unobserve(entry.target);
          });
        }, { rootMargin: '320px 0px' });
        videoButtons.forEach(function (button) { posterObserver.observe(button); });
      } else {
        videoButtons.forEach(loadVideoPoster);
      }

      videoButtons.forEach(function (button) {
        function activateVideo() {
          var videoId = button.getAttribute('data-video-id') || '';
          var player = qs('[data-tools-video-player]', button.parentNode);
          if (!player || !/^\d+$/.test(videoId) || player.dataset.loaded === 'true') return;

          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.tiktok.com/player/v1/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&controls=1&description=0&music_info=0';
          iframe.title = button.getAttribute('data-video-title') || 'Creator hands-on product video';
          iframe.loading = 'lazy';
          iframe.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.tabIndex = 0;
          player.dataset.loaded = 'true';
          player.hidden = false;
          player.appendChild(iframe);
          button.hidden = true;
          window.setTimeout(function () { iframe.focus(); }, 0);
        }

        button.addEventListener('click', activateVideo);
        button.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activateVideo();
        });
      });

      updateControls();
    });
  }

  function initInteractiveSections(root) {
    initVariantForms(root || document);
    initProductTabs(root || document);
    initCollectionFilters(root || document);
    initProductGalleries(root || document);
    initQuickAdd(root || document);
    initProductAdd(root || document);
    initStickyBuy(root || document);
    initHeroSliders(root || document);
    initQuantitySteppers(root || document);
    initWishlist(root || document);
    initProductSharing(root || document);
    initProductRecommendations(root || document);
    initBrandDirectories(root || document);
    initArticleTools(root || document);
    initGlossaryDirectories(root || document);
    initQuizzes(root || document);
    initToolsInAction(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initCategoryFlyouts();
    initCountdown();
    initPredictiveSearch();
    initBackToTop();
    initFirstOrderOffer();
    initInteractiveSections(document);
    trackCurrentProduct();
    renderRecent();
    renderWishlist();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initInteractiveSections(event.target);
  });
})();
